import { render, staticRenderFns } from "./MyItemsList.vue?vue&type=template&id=6806848a&"
import script from "./MyItemsList.vue?vue&type=script&lang=js&"
export * from "./MyItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports